<template>
  <div class="home">
    <menuBox :step="1"></menuBox>
    <div class="tes-box">
      <div class="text-box">Ayudar a los usuarios a resolver problemas de préstamos</div>
      <img src="../assets/img-2.png" alt="">
    </div>
    <div class="list-box">
      <div class="line-box"></div>
      <div class="title">Ventajas del producto</div>
      <div class="item-box">
        <div class="item">
          <img src="../assets/icon-1.png" alt="">
          <div>Aprobación rápida del préstamo</div>
          <p>La solicitud es sencilla y la aprobación se completa en 24 horas.</p>
        </div>
        <div class="item">
          <img src="../assets/icon-2.png" alt="">
          <div>Seguro y confiable</div>
          <p>La tecnología de cifrado avanzada garantiza la seguridad de la información y las transacciones personales.</p>
        </div>
        <div class="item">
          <img src="../assets/icon-3.png" alt="">
          <div>Método de pago conveniente</div>
          <p>Admite múltiples canales de pago, pagos flexibles y operación simple.</p>
        </div>
      </div>

    </div>

    <div class="sen-box">
      <div class="sen-left">
        <div class="title">Proceso de uso de la aplicación</div>
        <div class="bj-s-box">
          <p>Descargar</p>
          <p>Autenticación</p>
          <p>Enviar solicitud de préstamo</p>
        </div>
      </div>
      <img src="../assets/img-2.png" alt="">
    </div>
    <footerBox></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
  name: 'App',
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>


<style lang="less" scoped>
.tes-box {
  padding: 120px 360px;
  display: flex;
  align-items: center;
  justify-content: center;

  .text-box {
    font-size: 52px;
    font-weight: bold;
    color: #333333;
    width: 600px;
  }

  img {
    width: 590px;
  }
}

.line-box {
  width: 105px;
  height: 6px;
  background: linear-gradient(312deg, #3EBFBE 0%, #3FB9EE 100%);
  margin: auto;
}

.list-box {
  padding: 80px 360px;
  background: #E9F7F7;

  .title {
    font-size: 60px;
    font-weight: bold;
    color: #1A202C;
    margin-top: 26px;
    text-align: center;
  }

  .item-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 66px;

    .item {
      width: 273px;
      min-height: 187px;
      background: #FFFFFF;
      box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.05);
      border-radius: 7px 7px 7px 7px;
      opacity: 1;
      padding: 50px 30px;

      img {
        width: 58px;
      }

      div {
        font-size: 20px;
        font-weight: normal;
        color: #2D3748;
        margin-top: 20px;
      }

      p {
        font-size: 14px;
        font-weight: 400;
        color: #718096;
        margin-top: 20px;
      }
    }
  }
}

.sen-box {
  padding: 140px 360px;
  display: flex;
  align-content: center;
  justify-content: space-between;

  .sen-left {
    .title {
      font-size: 60px;
      font-weight: bold;
      color: #1A202C;
    }

    .bj-s-box {
      width: 500px;
      background: url(../assets/list.png) no-repeat;
      background-size: 21px 100%;
      min-height: 262px;
      margin-top: 90px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      p {
        margin-left: 30px;
        font-size: 36px;
        font-weight: 400;
        color: #333333;
      }
    }
  }

  img {
    width: 631px;

  }
}
</style>
